<!-- One tab glyph, centred in a 128x150-ratio tile (LINE's button canvas).
     The Phosphor mask paints in the tinted colour via CSS mask; the ON state
     emits a soft glow (the filter sits on the WRAPPER, a filter on the
     masked element itself would be clipped by the mask). -->
<div class="btn-tile" [class.g-tile]="g">
  <span class="g" [class.lit]="on" [style.--glow]="color">
    <!-- Sakura Home = a cherry BLOSSOM (like the passcode dots, sakura pink). ON
         = filled sakura-pink petals + golden stamen; OFF = a single-tint
         silhouette. Every other tab = the Phosphor mask glyph. -->
    <svg *ngIf="isTree && on" class="glyph-svg" viewBox="0 0 100 100"
         [style.width.%]="sizePct" aria-hidden="true">
      <g transform="translate(50,52) scale(0.86)">
        <path *ngFor="let r of blossomRots" [attr.d]="blossomPetal"
              [attr.transform]="'rotate(' + r + ')'" fill="#E898B4"></path>
        <circle cx="0" cy="0" r="8" fill="#FBE3A6"></circle>
        <circle cx="0" cy="0" r="3.6" fill="#F3B45E"></circle>
      </g>
    </svg>
    <svg *ngIf="isTree && !on" class="glyph-svg" viewBox="0 0 100 100"
         [style.width.%]="sizePct" [attr.fill]="color" aria-hidden="true">
      <g transform="translate(50,52) scale(0.86)">
        <path *ngFor="let r of blossomRots" [attr.d]="blossomPetal"
              [attr.transform]="'rotate(' + r + ')'"></path>
      </g>
    </svg>
    <!-- Tokyo Home = a Tokyo TOWER silhouette (shared glyph, so it can never
         drift from the phone preview). ON = filled red + lit decks; OFF =
         filled in the muted tab colour. -->
    <app-line-tower-glyph *ngIf="isTower" class="glyph-svg" [style.width.%]="sizePct"
                          [color]="color" [on]="on"></app-line-tower-glyph>
    <!-- Everest Home = the SUMMIT (same motif as its passcode dots). ON = the
         peak in sunrise orange with bright snowcaps; OFF = a plain silhouette
         in the muted icy tone. -->
    <svg *ngIf="isPeak" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <g transform="translate(0,6)">
        <path [attr.d]="peakBody" [attr.fill]="color"></path>
        <ng-container *ngIf="on">
          <path [attr.d]="peakCap" fill="#FFFFFF"></path>
          <path [attr.d]="peakCapSmall" fill="#FFFFFF"></path>
        </ng-container>
      </g>
    </svg>
    <!-- Aurora Home = the ORB (same motif as its passcode dots). ON = a
         blue-led aurora sky ringed in the same blue every other ON tab uses;
         OFF = a SOLID silhouette with the stars punched out of it, so the shape
         still reads as the same object rather than an empty ring
         (owner 2026-08-12). -->
    <svg *ngIf="isOrb" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <defs>
        <clipPath [attr.id]="'mboc-' + (on ? 'on' : 'off') + (g ? '-g' : '')">
          <circle cx="60" cy="60" [attr.r]="orbR"></circle>
        </clipPath>
      </defs>

      <g [attr.transform]="orbFit">

      <ng-container *ngIf="on">
        <circle cx="60" cy="60" [attr.r]="orbR" fill="#0C1720"></circle>
        <g [attr.clip-path]="'url(#mboc-on' + (g ? '-g' : '') + ')'">
          <circle *ngFor="let s of orbStars" [attr.cx]="s.cx" [attr.cy]="s.cy" [attr.r]="s.r"
                  fill="#FFFFFF" opacity="0.9"></circle>
          <path *ngFor="let b of orbBands" [attr.d]="b.d" [attr.fill]="b.fill"
                [attr.opacity]="b.o"></path>
        </g>
        <circle cx="60" cy="60" [attr.r]="orbR" fill="none" [attr.stroke]="color"
                stroke-width="5"></circle>
      </ng-container>

      <!-- OFF: an EMPTY sky with the three aurora bands drawn positively inside
           the ring (owner 2026-08-12). Filling the disc and punching a hole in it
           read as a smudge; showing the light itself keeps the same object
           recognisable with nothing lit. One hue, like every other OFF glyph. -->
      <ng-container *ngIf="!on">
        <g [attr.clip-path]="'url(#mboc-off' + (g ? '-g' : '') + ')'">
          <path *ngFor="let b of orbOffBands" [attr.d]="b" [attr.fill]="color"></path>
        </g>
        <circle cx="60" cy="60" [attr.r]="orbR" fill="none" [attr.stroke]="color"
                stroke-width="5"></circle>
      </ng-container>
      </g>
    </svg>
    <!-- Sequoia Home = the REDWOOD (same motif as its passcode dots). ON = the
         lit canopy over its trunk; OFF = one flat silhouette in the tab tone. -->
    <svg *ngIf="isSeq" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <defs>
        <linearGradient [attr.id]="'mbt-' + (on ? 'on' : 'off') + (g ? '-g' : '')"
                        x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" [attr.stop-color]="treeLight"></stop>
          <stop offset="0.55" [attr.stop-color]="treeMid"></stop>
          <stop offset="1" [attr.stop-color]="treeDark"></stop>
        </linearGradient>
      </defs>
      <ng-container *ngIf="on">
        <path [attr.d]="treeTrunk" [attr.fill]="treeBark"></path>
        <path [attr.d]="treeCanopy" [attr.fill]="'url(#mbt-on' + (g ? '-g' : '') + ')'"></path>
      </ng-container>
      <ng-container *ngIf="!on">
        <path [attr.d]="treeTrunk" [attr.fill]="color"></path>
        <path [attr.d]="treeCanopy" [attr.fill]="color"></path>
      </ng-container>
    </svg>
    <!-- Autumn Home = the MAPLE (same traced leaf as its passcode dots). ON =
         the lit blade; OFF = one flat silhouette in the tab tone. -->
    <svg *ngIf="isMaple" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <defs>
        <linearGradient [attr.id]="'mbm-' + (on ? 'on' : 'off') + (g ? '-g' : '')"
                        x1="0" y1="1" x2="0.25" y2="0">
          <stop offset="0" [attr.stop-color]="mapleDeep"></stop>
          <stop offset="0.5" [attr.stop-color]="mapleMid"></stop>
          <stop offset="1" [attr.stop-color]="mapleLight"></stop>
        </linearGradient>
      </defs>
      <path [attr.d]="mapleBlade"
            [attr.fill]="on ? 'url(#mbm-on' + (g ? '-g' : '') + ')' : color"></path>
    </svg>
    <!-- Roraima Home = the SETTING SUN (same glyph as its passcode dots). ON =
         the disc lit into the ON pink; OFF = the same object flat in the tab
         tone. The clip at the horizon is what makes it read as setting. -->
    <svg *ngIf="isSun" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <defs>
        <clipPath [attr.id]="'mbs-' + (on ? 'on' : 'off') + (g ? '-g' : '')">
          <rect x="0" y="0" width="120" [attr.height]="sunHorizonY"></rect>
        </clipPath>
        <linearGradient [attr.id]="'mbsg-' + (on ? 'on' : 'off') + (g ? '-g' : '')"
                        x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" [attr.stop-color]="on ? sunLight : color"></stop>
          <stop offset="1" [attr.stop-color]="color"></stop>
        </linearGradient>
      </defs>
      <g [attr.transform]="sunShift">
      <g [attr.clip-path]="'url(#mbs-' + (on ? 'on' : 'off') + (g ? '-g' : '') + ')'">
        <path [attr.d]="sunRaysD" fill="none" [attr.stroke]="color" stroke-width="5"
              stroke-linecap="round"></path>
        <circle cx="60" [attr.cy]="sunCy" [attr.r]="sunR"
                [attr.fill]="'url(#mbsg-' + (on ? 'on' : 'off') + (g ? '-g' : '') + ')'"></circle>
      </g>
      <path [attr.d]="sunHorizonD" fill="none" [attr.stroke]="color" stroke-width="6"
            stroke-linecap="round"></path>
      </g>
    </svg>
    <!-- Miami Home = the PALM (same tree as its passcode dots). ON = two tones,
         dark-pink trunk under a canopy in the tab colour, exactly as the passcode
         draws it; OFF = one flat silhouette. -->
    <svg *ngIf="isPalm" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <g [attr.transform]="palmFit">
        <path [attr.d]="palmTrunk" [attr.fill]="on ? palmTrunkInk : color"></path>
        <path [attr.d]="palmCrown" [attr.fill]="color"></path>
      </g>
    </svg>
    <!-- Istanbul Home = the KIZ KULESİ, traced from the theme's own icon. ON =
         the lit tower in four tones (stone walls, red roof + cornice, ink cap
         and collar, a brighter flag); OFF = the whole tower as ONE path in one
         flat tab tone, nonzero so the overlaps union instead of holing. -->
    <svg *ngIf="isMaiden" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <path [attr.d]="maidenBase" [attr.fill]="maidenStone"></path>
        <path [attr.d]="maidenShaft" [attr.fill]="maidenStone"></path>
        <path [attr.d]="maidenGallery" [attr.fill]="maidenStone"></path>
        <path [attr.d]="maidenRoof" [attr.fill]="maidenRoofTile"></path>
        <path [attr.d]="maidenCollar" [attr.fill]="maidenInk"></path>
        <path [attr.d]="maidenCap" [attr.fill]="maidenInk"></path>
        <path [attr.d]="maidenPole" [attr.fill]="maidenInk"></path>
        <path [attr.d]="maidenFlag" [attr.fill]="maidenFlagRed"></path>
        <path [attr.d]="maidenWindows" [attr.fill]="maidenInk" opacity="0.72"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="maidenSolid" [attr.fill]="color"
            fill-rule="nonzero"></path>
    </svg>
    <svg *ngIf="isEiffel" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <path [attr.d]="eiffelSolid" [attr.fill]="eiffelGold" fill-rule="evenodd"></path>
        <path [attr.d]="eiffelBase" [attr.fill]="eiffelDeep" fill-rule="evenodd"></path>
        <path [attr.d]="eiffelDecks" [attr.fill]="eiffelDeep"></path>
        <path [attr.d]="eiffelShadow" [attr.fill]="eiffelShade"></path>
        <path [attr.d]="eiffelLamps" [attr.fill]="eiffelLamp"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="eiffelSolid" [attr.fill]="color"
            fill-rule="evenodd"></path>
    </svg>
    <svg *ngIf="isParasol" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <g [attr.transform]="parasolTransform">
        <ng-container *ngIf="on">
          <path [attr.d]="parasolB" [attr.fill]="parasolYellow" fill-rule="nonzero"></path>
          <path [attr.d]="parasolA" [attr.fill]="parasolGreen" fill-rule="nonzero"></path>
          <path [attr.d]="parasolPole" [attr.fill]="parasolGreen" fill-rule="nonzero"></path>
        </ng-container>
        <path *ngIf="!on" [attr.d]="parasolSolid" [attr.fill]="color"
              fill-rule="nonzero"></path>
      </g>
    </svg>
    <!-- Ocean Home = a DENİZANASI, the shared jellyfish. ON = the bell lit in
         the tab colour over deeper strands, with a pale crest inside the dome;
         OFF = the whole animal as one flat silhouette. -->
    <!-- Salda Home = a DENİZ KABUĞU, the shared scallop. ON = the shell in the
         tab colour with its ribs a step deeper; OFF = one flat silhouette. -->
    <!-- Prague Home = a SOKAK LAMBASI, the shared gas street lamp. ON = the
         ironwork in the tab colour with its four panes LIT; OFF = one flat
         silhouette, iron and glass together. -->
    <svg *ngIf="isLamp" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <path [attr.d]="lampGlass" [attr.fill]="lampLit" fill-rule="nonzero"></path>
        <path [attr.d]="lampIron" [attr.fill]="color" fill-rule="nonzero"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="lampSolid" [attr.fill]="color"
            fill-rule="nonzero"></path>
    </svg>
    <!-- Fuji Home = the MOUNTAIN itself. ON = the rock in the tab colour with its
         snowcap in near-white; OFF = the bare silhouette. -->
    <svg *ngIf="isFuji" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <path [attr.d]="fujiMount" [attr.fill]="color"></path>
      <!-- THE SNOWCAP IS DRAWN IN BOTH STATES. It used to be on the selected tab
           only, and the idle tab was a plain triangle — which is a hill, not Fuji.
           This mountain has exactly one identifying feature and throwing it away is
           not a way of saying "unlit"; every other theme's OFF state keeps its
           subject and only drops its colour. On the idle tab the cap is cut in the
           bar's own fill, so it reads as the rock being taken away rather than as a
           white hat added on — the trick the wallpaper already used. -->
      <path [attr.d]="fujiSnow" [attr.fill]="on ? fujiSnowColor : fujiSnowCut"></path>
    </svg>
    <!-- Etna Home = a YANARDAĞ, the shared volcano. ON = the cone in dark rock
         with lava running out of a lit crater and a faint plume over it; OFF = one
         flat silhouette with nothing coming out of it. -->
    <svg *ngIf="isVolcano" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <path [attr.d]="volcanoPlume" [attr.fill]="volcanoAsh" opacity="0.95"
              fill-rule="nonzero"></path>
        <path [attr.d]="volcanoShoulder" [attr.fill]="volcanoRock"></path>
        <path [attr.d]="volcanoCone" [attr.fill]="volcanoRock"></path>
        <path [attr.d]="volcanoRiver" [attr.fill]="color" fill-rule="nonzero"></path>
        <path [attr.d]="volcanoFissure" [attr.fill]="color" fill-rule="nonzero"></path>
        <path [attr.d]="volcanoGlow" [attr.fill]="volcanoVent"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="volcanoSolid" [attr.fill]="color"
            fill-rule="nonzero"></path>
    </svg>
    <!-- Madrid Home = the CLAVEL, the carnation. ON = the head in the tab colour
         over a deeper inner ring, on foliage in the theme's fixed green; OFF = the
         whole plant as one flat silhouette. -->
    <svg *ngIf="isClavel" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <path [attr.d]="clavelFoliage" [attr.fill]="clavelGreen" fill-rule="nonzero"></path>
        <path [attr.d]="clavelHead" [attr.fill]="color" fill-rule="nonzero"></path>
        <path [attr.d]="clavelInner" [attr.fill]="clavelShade" fill-rule="nonzero"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="clavelSolid" [attr.fill]="color"
            fill-rule="nonzero"></path>
    </svg>
    <!-- Vienna Home = a KEMAN, the shared violin. ON = the instrument in the tab
         colour with its f-holes and bridge cut in dark; OFF = one flat silhouette.
         NO STRINGS here. They are 0.9 units wide in a 120 box, which is a third of
         a pixel once the tab renders at 22px: four sub-pixel lines do not read as
         strings, they read as a smear over the one part of the instrument that has
         to stay clean. The passcode dot draws them, because there the same glyph
         has five times the room. -->
    <svg *ngIf="isViolin" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <g [attr.transform]="violinPose || null">
        <ng-container *ngIf="on">
          <path [attr.d]="violinSolid" [attr.fill]="color" fill-rule="nonzero"></path>
          <path [attr.d]="violinFholes" [attr.fill]="violinInside" fill-rule="nonzero"></path>
          <path [attr.d]="violinBridge" [attr.fill]="violinInside"></path>
        </ng-container>
        <path *ngIf="!on" [attr.d]="violinSolid" [attr.fill]="color"
              fill-rule="nonzero"></path>
      </g>
    </svg>
    <!-- Spring Home = a ÇAN ÇİÇEĞİ, the shared bellflower. ON = the bell in the
         tab colour on a green stem with a deep throat inside its mouth; OFF = one
         flat silhouette. -->
    <svg *ngIf="isFlower" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <!-- stem and leaf come from the solid path, then the head over them, so
             the ring of petals is never cut by the stem behind it -->
        <!-- foliage in its own green, then the cup over it in the tab colour,
             then the two outer petals a shade deeper -->
        <path [attr.d]="flowerFoliage" [attr.fill]="flowerGreen" fill-rule="nonzero"></path>
        <path [attr.d]="flowerHead" [attr.fill]="color"></path>
        <path [attr.d]="flowerShade" [attr.fill]="flowerShadeTone"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="flowerSolid" [attr.fill]="color"
            fill-rule="nonzero"></path>
    </svg>
    <!-- Reynisfjara Home = a DENİZ KAYASI, the shared Reynisdrangar stacks. ON =
         warm rock in the tab colour standing in cold slate water; OFF = one flat
         silhouette, water and all. -->
    <!-- Reynisfjara Home = a PUFİN, the shared bird. It replaced three sea stacks:
         a dark lump is not charming at any size. ON is nine layers, each a
         material; OFF is one flat silhouette. -->
    <svg *ngIf="isBasalt" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <!-- lit faces, shaded faces, then the broken tops over both. The two face
             tones are what separate columns that physically touch — drawn apart
             they stop being basalt and become a fence. -->
        <path [attr.d]="basaltFaces" [attr.fill]="color" fill-rule="nonzero"></path>
        <path [attr.d]="basaltFacesAlt" [attr.fill]="basaltAltTone" fill-rule="nonzero"></path>
        <path [attr.d]="basaltTops" [attr.fill]="basaltTopTone" fill-rule="nonzero"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="basaltSolid" [attr.fill]="color"
            fill-rule="nonzero"></path>
    </svg>
    <!-- Sydney Home = a YELKENLİ, the shared harbour yacht. It replaced the Opera
         House: a landmark is a postcard, and one shell of that building read as a
         shark fin on the wallpaper. ON is three tones, each a material; OFF is one
         flat silhouette. -->
    <svg *ngIf="isYacht" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <path [attr.d]="yachtHull" [attr.fill]="yachtHullTone"></path>
        <path [attr.d]="yachtMast" [attr.fill]="yachtHullTone" fill-rule="nonzero"></path>
        <path [attr.d]="yachtMain" [attr.fill]="color"></path>
        <path [attr.d]="yachtJib" [attr.fill]="yachtJibTone"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="yachtSolid" [attr.fill]="color"
            fill-rule="nonzero"></path>
    </svg>
    <svg *ngIf="isShell" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <path [attr.d]="shellEars" [attr.fill]="shellRibColor" fill-rule="nonzero"></path>
        <path [attr.d]="shellBody" [attr.fill]="color" fill-rule="nonzero"></path>
        <path [attr.d]="shellRibs" [attr.fill]="shellRibColor" opacity="0.8"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="shellSolid" [attr.fill]="color"
            fill-rule="nonzero"></path>
    </svg>
    <svg *ngIf="isJelly" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <ng-container *ngIf="on">
        <path [attr.d]="jellyTentacles" [attr.fill]="jellyStrand" fill-rule="nonzero"></path>
        <path [attr.d]="jellyArms" [attr.fill]="jellyStrand" fill-rule="nonzero"></path>
        <path [attr.d]="jellyBell" [attr.fill]="color" fill-rule="nonzero"></path>
        <!-- capillaries: under the crest, so the lit side of the bell still reads
             as one surface and the vessels sit INSIDE the body rather than on it -->
        <path [attr.d]="jellyVeinsMain" [attr.fill]="jellyVeinBlue"
              fill-rule="nonzero"></path>
        <path [attr.d]="jellyVeinsFine" [attr.fill]="jellyVeinPink"
              fill-rule="nonzero"></path>
        <path [attr.d]="jellyCrest" [attr.fill]="jellyCrestColor" opacity="0.9"></path>
      </ng-container>
      <path *ngIf="!on" [attr.d]="jellySolid" [attr.fill]="color"
            fill-rule="nonzero"></path>
    </svg>
    <svg *ngIf="isSnowflake" class="glyph-svg" viewBox="0 0 120 120"
         [style.width.%]="sizePct" aria-hidden="true">
      <path [attr.d]="snowflake" [attr.fill]="color" fill-rule="nonzero"></path>
    </svg>
    <span *ngIf="!isTree && !isTower && !isPeak && !isOrb && !isSeq && !isMaple && !isSun && !isPalm && !isMaiden && !isEiffel && !isParasol && !isSnowflake && !isJelly && !isShell && !isLamp && !isYacht && !isBasalt && !isFlower && !isViolin && !isClavel && !isVolcano && !isFuji" class="glyph"
          [style.--mask]="maskUrl"
          [style.background]="color"
          [style.width.%]="sizePct"
          aria-hidden="true"></span>
  </span>
</div>
